import { render } from "./AccountDeleted.vue?vue&type=template&id=1f713be6&scoped=true"
import script from "./AccountDeleted.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDeleted.vue?vue&type=script&setup=true&lang=js"

import "./AccountDeleted.vue?vue&type=style&index=0&id=1f713be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f713be6"],['__file',"src/views/AccountDeleted.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f713be6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f713be6', __exports__)) {
    api.reload('1f713be6', __exports__)
  }
  
  module.hot.accept("./AccountDeleted.vue?vue&type=template&id=1f713be6&scoped=true", () => {
    api.rerender('1f713be6', render)
  })

}


export default __exports__